<accredible-base-header-menu [dynamicMenuItems]="dynamicMenuItems"
  [staticMenuItems]="staticMenuItems"
  [user]="user$ | async"
  [redrawObservable]="languageCode$">
</accredible-base-header-menu>
